import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import AddIcon from "@mui/icons-material/Add";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "../../../WorkSpace/font.css";
import { useHistory, useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import swal from "sweetalert";
import { useState, useEffect } from "react";
import { BrowsFsAdditional, CreateAddinalData, fetchAddinalData, getCompany, GetConsoleEntryData, GetProjectsBasedOnUserId, getSingleAllDetails, GetConsoleEntryDataAdditional, addAllOtherOptionsAdditional, getAllOtherOptionsAdditional, getAllOtherDetailsAdditional, addOtherDetailsAdditional, deleteAllOtherDetailsAdditional, addAllOtherDetailsAdditional, saveAdditionalIrDetails } from "../../../WorkSpace/Components/ApiServices/apiHandler";
import InvestAdjustModal from "../../../Console/Component/InvestAdjustmentModal";
import BrowsFsModal from "../../../WorkSpace/Components/InvestRegister/Modals/BrowsFSModal";
import { toast } from "react-toastify";
import ConsoleEntryModal from "../../../WorkSpace/Components/InvestRegister/Modals/ConsoleEntryModal";
import AddOtherDetailsModal from "../../../WorkSpace/Components/InvestRegister/Modals/AddOtherDetailsModal";
import AddNewOptionsModal from "../../../WorkSpace/Components/InvestRegister/Modals/AddNewOptionsModal";
import { useDispatch, useSelector } from "react-redux";
import { fetchAdditionalDetailsData } from "../../../redux/actions/InvestmentRegister/actionAdditionalOthersData";
import { fetchAllDetailsData } from "../../../redux/actions/InvestmentRegister/actionAllOthersData";

import dayjs from "dayjs";
import Select from "react-select";
import Radio from "@mui/material/Radio";
import makeAnimated from "react-select/animated";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { motion } from "framer-motion";
import { Button } from "../../../myfin_v2/elements/Button";
import IRMenu from "./IRMenu"
import Sidebar from "../../../myfin_v2/elements/Sidebar";
import CustomDropdownIndicator from "../../../myfin_v2/elements/CustomDropdownIndicator";
import InputGroup from "../../../myfin_v2/elements/InputGroup";
import commoncss from "../../../myfin_v2/css/common.module.css";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import investmentRegisterCss from "../../../myfin_v2/css/investmentRegister.module.css";
import ConsoleEntry from "../../../myfin_v2/components/investmentregister/ConsoleEntry";
import { ReactComponent as PlusPrimaryIcon } from "../../../myfin_v2/assets/icons/plusprimary.svg";
import { ReactComponent as MinusPrimaryIcon } from "../../../myfin_v2/assets/icons/minusprimary.svg";
import { ReactComponent as CalenderIcon } from "../../../myfin_v2/assets/icons/calender.svg";
import { ReactComponent as CrossGreyIcon } from "../../../myfin_v2/assets/icons/crossGrey.svg";
import { ReactComponent as AttachmentIcon } from "../../../myfin_v2/assets/icons/attachment.svg";

export const customStyles = {
    control: (provided, state) => ({
        ...provided,
        backgroundColor: '#f4faf5',
        borderColor: '#c2e6d1',
        color: '#b3c0bd',
        boxShadow: state.isFocused ? '0 0 0 1px #c2e6d1' : 'none',
        borderWidth: '1px',
        borderRadius: '10px',
        '&:hover': {
            borderColor: '#b3c0bd',
        },
        minHeight: '38px',
        height: '38px',
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: '2px 8px',
        paddingTop: '1px',
    }),
    input: (provided) => ({
        ...provided,
        color: '#b3c0bd',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        fontSize: '14px',
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#4d6d64',
        fontSize: '14px',
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: '#e0f5e9',
        borderRadius: '0.25rem',
        border: '1px solid #c2e6d1',
        width: 'fit-content',
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: '#4d6d64',
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        ':hover': {
            backgroundColor: '#c2e6d1',
            color: '#4f665f',
        },
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        color: '#b3c0bd',
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: '#1A4338',
        fontWeight: 400,
        ':hover': {
            color: '#1A4338',
            fontWeight: 400,
        },
    }),
    clearIndicator: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        ':hover': {
            color: '#4f665f',
        },
    }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: '#ffffff',
        border: '1px solid #c2e6d1',
        borderRadius: '6px',
        boxShadow: '0 0 0 1px #c2e6d1',
        marginTop: '6px',
        zIndex: 10,
    }),
    menuList: (provided) => ({
        ...provided,
        padding: '4px',
        borderRadius: '6px',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected
            ? '#c2e6d1'
            : state.isFocused
                ? '#f4faf5'
                : 'transparent',
        color: '#4f665f',
        padding: '10px 12px',
        cursor: 'pointer',
        fontSize: '14px',
        borderRadius: '8px',
        // margin: '4px 6px',
    }),
    noOptionsMessage: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        padding: '8px 12px',
    }),
};

const companyRelationShip = ["Subsidiary Company", "Associate Company", "Investment"]
const InvestmentData = (props) => {
    // new usestates
    const user_id = localStorage.getItem("user_id");
    const dispatch = useDispatch();
    const animatedComponents = makeAnimated();
    const [details, setDetails] = useState({
        companyCode: "",
        browseFsCompanyId: "",
        details_id: ""
    })
    const [isBrowsModalOpen, setIsBrowsModalOpen] = useState(false);
    const [allProjects, setAllProjects] = useState([]);
    const [isConsoleEntryOpen, setIsConsoleEntryOpen] = useState(false);
    const [allConsoleEntry, setAllConsoleEntry] = useState([]);
    const [isOtherInputOpen, setIsOtherInputOpen] = useState(false);
    const [allOtherDetailsInputs, setOtherDetailsInputs] = useState([]);
    const [isOptionsModalOpen, setIsOptionsModalOpen] = useState(false);
    const [otherOptions, setOtherOptions] = useState([]);
    const [options, setOptions] = useState('');
    const [consoleInvestmentValue, setConsoleInvestmentValue] = useState(0);
    const [allDetailsId, setAllDetailsId] = useState('');
    const [showFirstTable, setShowFirstTable] = useState(true);
    const [additinalData, setAdditinalData] = useState([]);
    const [isAdditional, setIsAdditional] = useState(false);
    const [projects, setProjects] = useState([]);

    const all_othersData = useSelector((state) => state.AllOtherDetailsReducer);

    const additional_othersData = useSelector((state) => state.AdditionalOtherDetailsReducer);

    const location = useLocation();
    const [open, setOpen] = React.useState(false);
    const [open1, setOpen1] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleOpen1 = () => setOpen1(true);
    const [browseOpen, setBrowseOpen] = useState(false);
    const [eqityshare, setEquityShare] = useState([]);
    const [otherequityshare, setOtherEquityShare] = useState("");
    const [otherreservesurplus, setOtherReserveSurplus] = useState("");
    const [othereserve, setOtherReserve] = useState("");
    const [setfinalsum, setFinalSum] = useState("");
    const [totaldata, setDataTotal] = useState("");
    const [interest, setInterest] = useState("");
    const [entryopenModal, setEntryOpen] = useState(false);
    const [openconsoleentry, setOpenConsoleEntry] = useState(false);
    const [finalnoofshar, setFinalNoOfShare] = useState("");
    const [finalinvestment, setFinalInvestment] = useState("");
    const [noofdevest, setNoOfDevest] = useState("");
    const [allCompany, setAllCompany] = useState([]);
    const [investvalue, setInvestValue] = useState("");
    const [totaleqity, setTotalEquity] = useState(eqityshare * -1);
    const [finalconsoleentry, setFinalConsoleEntry] = useState({});
    const [dilutiondata, setDilutionData] = useState({
        date_of_divest: "",
        no_of_share: "",
        sale: "",
    });
    const [registerdata, setRegisterDAta] = useState([]);
    const [dateofinvest, setDateOfInvest] = useState(
        registerdata?.date_Of_investment
    );
    const [investmentValue, setInvestmentValue] = useState(0);
    const [totalHoldings, setTotalHoldings] = useState(0);
    const [totalShares, setTotalShares] = useState(0);
    const [finalHoldings, setFinalHoldings] = useState(0);

    const [extraDetails, setExtraDetails] = useState({});
    const [extraAdditionalDetails, setExtraAdditionalDetails] = useState({});



    let no_of_share = Number(registerdata?.no_of_shares) + finalnoofshar;
    let final_investment =
        Number(registerdata?.value_of_investment) + finalinvestment;
    let dataValue = (Number(no_of_share) / Number(final_investment)) * noofdevest;
    let history = useHistory();
    let a = location.pathname;
    let b = a.split("/");
    const registerID = b[2]
    const handleClose = () => {
        setOpen(false);
        setOpen1(false);
        setBrowseOpen(false);
        setEntryOpen(false);
        setOpenConsoleEntry(false);
    };

    useEffect(() => {
        AllRegisterData();
        fetchAdditionData();
        companyData();
        GetProjects();
        GetAllProjects();
    }, []);

    useEffect(() => {
        setTotalHoldings(
            additinalData
                ?.filter(item => item?.investment_company_id === registerdata[0]?.investment_company_id)
                .reduce((acc, item) => acc + parseInt(item?.holdings || 0, 10), 0) +
            parseInt(registerdata[0]?.holdings || 0, 10)
        );
        setTotalShares(
            additinalData
                ?.filter(item => item?.investment_company_id === registerdata[0]?.investment_company_id)
                .reduce((acc, item) => acc + parseInt(item?.no_of_shares || 0, 10), 0) +
            parseInt(registerdata[0]?.no_of_shares || 0, 10)
        );

        setFinalHoldings(
            parseInt(registerdata[0]?.holdings || 0, 10) +
            additinalData
                ?.slice(0, -1)
                .filter(item => item?.investment_company_id === registerdata[0]?.investment_company_id)
                .reduce((acc, item) => acc + parseInt(item?.holdings || 0, 10), 0)
        );


        setInvestmentValue(
            additinalData
                ?.filter(item => item?.investment_company_id === registerdata[0]?.investment_company_id)
                .reduce((acc, item) => acc + parseInt(item?.value_of_investment || 0, 10), 0) +
            parseInt(registerdata[0]?.value_of_investment || 0, 10)
        );

    }, [additinalData]);


    const GetProjects = async () => {
        GetProjectsBasedOnUserId(user_id).then(response => {
            setProjects(response.data?.result)
        }).catch(error => {
            console.log("error", error)
        })
    };

    const companyData = async () => {
        try {
            const res = await getCompany();
            if (res.status === 200) {
                setAllCompany(res.data.getCompany);
            }
        } catch (error) {
            console.log(error.message, "error");
        }
    };

    const CompanyName = (c_id) => {
        try {
            const nameCompany = allCompany.filter((adj) => adj._id === c_id);
            const result = nameCompany[0]?.company_name
                ? nameCompany[0]?.company_name
                : "";
            return result;
        } catch (error) {
            return 0;
        }
    };

    const handleBAck = () => {
        history.push(`/detailsIR/${registerdata[0].ir_id}`);
    };

    // New Functionalities
    const AllRegisterData = async () => {
        getSingleAllDetails(b[3]).then(response => {
            setRegisterDAta(response.data.otherData);
            dispatch(fetchAllDetailsData(response.data.otherData[0]._id));
        }).catch(error => {
            console.log("error", error)
        })
    };

    const fetchAdditionData = async () => {
        const id = b[3];
        fetchAddinalData(id).then(response => {
            setAdditinalData(response.data.fetchAddinal);
        }).catch(error => {
            console.log("error", error)
        })
    };

    const HandleChange = (e, index) => {
        const { name, value } = e.target;

        setAdditinalData(prev =>
            prev.map((item, idx) => {
                if (idx !== index) return item;

                const updatedItem = { ...item, [name]: value };

                if (name === "investment_company_id") {
                    const resultCompany = allCompany.find(
                        (det) => det?._id === value
                    );
                    console.log("resultCompany", resultCompany);

                    updatedItem.investment_company_code = resultCompany?.company_code ?? "";
                }

                if (name === "no_of_shares" || name === "total_no_shares") {
                    const noOfShares = name === "no_of_shares"
                        ? parseFloat(value)
                        : parseFloat(item.no_of_shares);
                    const totalNoShares = name === "total_no_shares"
                        ? parseFloat(value)
                        : parseFloat(item.total_no_shares);

                    if (!isNaN(noOfShares) && !isNaN(totalNoShares) && totalNoShares !== 0) {
                        const holdings = (noOfShares / totalNoShares) * 100;
                        updatedItem.holdings = holdings;
                        updatedItem.non_controlling_interest = 100 - holdings;
                        if (registerdata[0]?.investment_company_id === item.investment_company_id) {
                            if (totalHoldings >= 51) {
                                updatedItem.nature_of_relationship = "Subsidiary Company";
                            } else if (totalHoldings >= 20 && totalHoldings < 51) {
                                updatedItem.nature_of_relationship = "Associate Company";
                            } else {
                                updatedItem.nature_of_relationship = "Investment";
                            }
                        } else if (holdings >= 51) {
                            updatedItem.nature_of_relationship = "Subsidiary Company";
                        } else if (holdings >= 20 && holdings < 51) {
                            updatedItem.nature_of_relationship = "Associate Company";
                        } else {
                            updatedItem.nature_of_relationship = "Investment";
                        }
                    } else {
                        updatedItem.holdings = 0;
                        updatedItem.non_controlling_interest = 0;
                        updatedItem.nature_of_relationship = "Investment";
                    }
                }

                console.log("updatedItem", updatedItem);
                return updatedItem;

            })
        );
    };

    const GetAllConsoleEntry = async (ir) => {
        const data = {
            non_controlling_interest: ir.non_controlling_interest,
            investment_value: -ir.value_of_investment,
        };
        GetConsoleEntryData(ir._id, data)
            .then((response) => {
                const result = response.data?.result;
                setIsConsoleEntryOpen(true);
                setAllConsoleEntry(result?.console_entry);

                setRegisterDAta((prev) =>
                    prev.map((item) => {
                        if (item._id === result._id) {
                            return { ...item, console_entry: result?.console_entry };
                        }
                        return item;
                    })
                );
            })
            .catch((error) => {
                swal(
                    "Error",
                    error?.response?.data?.error || "something went wrong",
                    "error"
                );
            });
    };

    const GetAllProjects = async () => {
        GetProjectsBasedOnUserId(user_id).then(response => {
            setIsBrowsModalOpen(true);
            setAllProjects(response.data?.result)
        }).catch(error => {
            console.log("error", error)
        })
    };

    // add Others Details new Options
    const addNewOptionsDetails = async () => {
        const data = {
            otherDatailsId: allDetailsId,
            options: options
        }
        const res = await addAllOtherOptionsAdditional(data);
        if (res.status === 201) {
            setIsOptionsModalOpen(false);
            setAdditinalData((prev) =>
                prev.map((item) => {
                    if (item._id === res.data.result._id) {
                        return { ...item, other_details_options: res.data.result?.other_details_options };
                    }
                    return item;
                })
            );
            getOthersDetailsOptions();
        }
    };
    //get other Details options
    const getOthersDetailsOptions = async () => {
        const res = await getAllOtherOptionsAdditional(allDetailsId);
        if (res.status === 201) {
            setOtherOptions(res.data.options);
        }
    };
    //get all others Details
    const getOthersDetails = async () => {
        const res = await getAllOtherDetailsAdditional(allDetailsId);
        if (res.status === 201) {
            setIsOtherInputOpen(true)
            setOtherDetailsInputs(res.data.other_items);
            getOthersDetailsOptions();
            // dispatch(fetchAdditionalDetailsData(allDetailsId));
        }
    };
    // add  new row in others details
    const addNewOthersDetails = async () => {
        const data = {
            otherDatailsId: allDetailsId,
            other_items: allOtherDetailsInputs
        }
        const res = await addOtherDetailsAdditional(data);
        if (res.status === 201) {
            getOthersDetails();
        }
    };
    //delete others details 
    const deleteOthersDetails = async (index) => {
        const data = {
            otherDatailsId: allDetailsId,
            index: index
        }
        const res = await deleteAllOtherDetailsAdditional(data);
        if (res.status === 201) {
            getOthersDetails();
        }
    };

    // add all others details data
    const addAllOthersDetails = async () => {
        const data = {
            otherDatailsId: allDetailsId,
            other_items: allOtherDetailsInputs
        }
        const res = await addAllOtherDetailsAdditional(data);
        if (res.status === 201) {
            setIsOtherInputOpen(false);
            setAdditinalData((prev) =>
                prev.map((item) => {
                    if (item._id === res.data.result._id) {
                        return { ...item, other_items: res.data.result?.other_items };
                    }
                    return item;
                })
            );
            dispatch(fetchAdditionalDetailsData(allDetailsId));
        }
    };

    const ProjectName = (p_id) => {
        const ProjectData = projects.find((adj) => adj._id === p_id);
        return ProjectData?.project_name || '';
    };

    const handleChangeInputs = (e) => {
        setConsoleInvestmentValue(e.target.value);
    }

    const handleNext = (ir) => {
        const data = {
            non_controlling_interest: registerdata[0]?.investment_company_id === ir.investment_company_id ? 100 - totalHoldings : ir.non_controlling_interest,
            investment_value: registerdata[0]?.investment_company_id === ir.investment_company_id ? -(Number(investmentValue) + Number(consoleInvestmentValue)) : -(Number(ir.value_of_investment) + Number(consoleInvestmentValue)),
        };

        GetConsoleEntryDataAdditional(ir._id, data)
            .then((response) => {
                const result = response.data?.result;
                setShowFirstTable(false);
                setAllConsoleEntry(result?.console_entry);

                setAdditinalData((prev) =>
                    prev.map((item) => {
                        if (item._id === result._id) {
                            return { ...item, console_entry: result?.console_entry };
                        }
                        return item;
                    })
                );
            })
            .catch((error) => {
                swal(
                    "Error",
                    error?.response?.data?.error || "something went wrong",
                    "error"
                );
            });
    };

    const handleSubmitFs = () => {
        const data = {
            project_id: details.browseFsCompanyId,
            details_id: details.details_id
        }

        BrowsFsAdditional(data).then(response => {
            toast.success("Brows FS mapped successfully.");
            setIsBrowsModalOpen(false);
            GetProjects();
            setAdditinalData((prev) =>
                prev.map((item) => {
                    if (item._id === response.data?.result._id) {
                        return { ...item, prepare_preset_project_id: response.data?.result.prepare_preset_project_id };
                    }
                    return item;
                })
            );
        }).catch(error => {
            console.log("browsfs error", error)
        })
    };

    const GetAllConsoleEntryAdditional = async (ir) => {
        const data = {
            non_controlling_interest: registerdata[0]?.investment_company_id === ir.investment_company_id ? 100 - totalHoldings : ir.non_controlling_interest,
            investment_value: registerdata[0]?.investment_company_id === ir.investment_company_id ? -investmentValue : -ir.value_of_investment,
        };

        GetConsoleEntryDataAdditional(ir._id, data)
            .then((response) => {
                const result = response.data?.result;
                setIsConsoleEntryOpen(true);
                setAllConsoleEntry(result?.console_entry);

                setAdditinalData((prev) =>
                    prev.map((item) => {
                        if (item._id === result._id) {
                            return { ...item, console_entry: result?.console_entry };
                        }
                        return item;
                    })
                );
            })
            .catch((error) => {
                swal(
                    "Error",
                    error?.response?.data?.error || "something went wrong",
                    "error"
                );
            });
    };

    function handleChangeDetails(e, field, i) {
        const { value } = e.target;
        if (value === "Add_new") {
            setIsOptionsModalOpen(true);
        } else {
            const newArray = allOtherDetailsInputs.map((item, index) => {
                if (i === index) {
                    return { ...item, [field]: value };
                }
                return item;
            });
            setOtherDetailsInputs(newArray);
        }
    }

    const createNewAdditional = async () => {
        const data = {
            register_id: b[3],
            cid: registerdata[0]?.investment_company_id
        }
        const res = await CreateAddinalData(data);
        if (res.status === 200) {
            // history.push(`/additionInvestregister/${res.data.result._id}`)
            fetchAdditionData();
        }
    };

    const saveAllAdditionalIrsDetails = async () => {
        const data = {
            register_id: b[3],
            allIrData: additinalData,
            ir_id: registerdata[0].ir_id
        }
        const res = await saveAdditionalIrDetails(data);
        if (res.status === 200) {
            fetchAdditionData();
            AllRegisterData();
            history.push(`/detailsIR/${registerdata[0].ir_id}`);
            swal("Success", "All IR Data Save Successfully", 'success');
        }
    };

    const companyOptions = allCompany.map((det) => ({
        label: det.company_name,
        value: det._id,
    }));

    const handleAddDetail = (type, index) => {
        const updater = type === "register" ? setExtraDetails : setExtraAdditionalDetails;
        updater((prev) => ({
            ...prev,
            [index]: [...(prev[index] || []), { field1: "", field2: "" }],
        }));
    };

    const handleDetailChange = (type, index, detailIndex, field, value) => {
        const updater = type === "register" ? setExtraDetails : setExtraAdditionalDetails;
        updater((prev) => {
            const updated = [...(prev[index] || [])];
            updated[detailIndex] = { ...updated[detailIndex], [field]: value };
            return { ...prev, [index]: updated };
        });
    };

    const handleRemoveDetail = (type, index, detailIndex) => {
        const updater = type === "register" ? setExtraDetails : setExtraAdditionalDetails;
        updater((prev) => {
            const updated = [...(prev[index] || [])];
            updated.splice(detailIndex, 1);
            return { ...prev, [index]: updated };
        });
    };

    return (
        <>
            <div className={commoncss.pageLayout}>
                <Sidebar />
                <div className={`d-flex ${commoncss.pageContent}`}>
                    <IRMenu
                        activeTab={"Investments"}
                        registerID={b[2]}
                    />
                    <motion.div
                        initial={{ y: -100, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        exit={{ y: 0, opacity: 0 }}
                        transition={{ duration: 0.5, ease: "easeInOut" }}
                        className={investmentRegisterCss.irLayout}
                    >
                        <div className={investmentRegisterCss.iDHeader}>
                            <div>
                            </div>
                            <div className="d-flex" style={{ gap: "10px" }}>
                                <Button
                                    btnColor={buttoncss.greyBg}
                                    icon={<PlusPrimaryIcon />}
                                    label="Add"
                                    onClick={() => createNewAdditional()}
                                />
                                <Button
                                    btnColor={buttoncss.greyBg}
                                    icon={<MinusPrimaryIcon height={16} />}
                                    label="Dilute"
                                    onClick={handleOpen}
                                />
                                <Button
                                    btnColor={buttoncss.primary}
                                    label="Save Details"
                                    onClick={saveAllAdditionalIrsDetails}
                                />
                            </div>
                        </div>
                        <div className={investmentRegisterCss.iDContainer}>
                            <div>
                                <div style={{ padding: "10px" }}>
                                    {registerdata.length > 0 &&
                                        registerdata.map((item, i) => (
                                            <>
                                                <Accordion className={investmentRegisterCss.accordian}>
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon />}
                                                        aria-controls="panel1a-content"
                                                        id="panel1a-header"
                                                        className={investmentRegisterCss.accordianHeader}
                                                    >
                                                        <div className={investmentRegisterCss.accordianHeaderContent}>
                                                            <span style={{ fontWeight: "600" }}>TRANCH {i + 1} <span style={{ marginLeft: "20px" }}>{item.date_Of_investment}</span></span>
                                                            <span style={{ marginRight: "20px", color: "#111111" }}> Investment value &nbsp;&nbsp; {Math.round(item.value_of_investment)}</span>
                                                        </div>

                                                    </AccordionSummary>
                                                    <AccordionDetails>
                                                        <div>
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <span className="input-label">Select Investment Company</span>
                                                                    <Select
                                                                        placeholder="Select Investment Company"
                                                                        name="investment_company_id"
                                                                        options={allCompany.map((det) => ({
                                                                            label: det.company_name,
                                                                            value: det._id,
                                                                        }))}
                                                                        className={`basic-multi-select w-100 mt-1 mb-2`}
                                                                        classNamePrefix="select"
                                                                        components={{
                                                                            ...animatedComponents,
                                                                            IndicatorSeparator: () => null,
                                                                            DropdownIndicator: CustomDropdownIndicator,
                                                                        }}
                                                                        styles={customStyles}
                                                                        onChange={(selectedOption) =>
                                                                            HandleChange(
                                                                                {
                                                                                    target: {
                                                                                        name: "investment_company_id",
                                                                                        value: selectedOption?.value || "",
                                                                                    },
                                                                                },
                                                                                i
                                                                            )
                                                                        }
                                                                        value={companyOptions.find((opt) => opt.value === item?.investment_company_id) || null}
                                                                        isDisabled={true}
                                                                    />
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <InputGroup
                                                                        label=" Company code"
                                                                        inputs={[
                                                                            <>
                                                                                <input
                                                                                    type="text"
                                                                                    value={item?.investment_company_code}
                                                                                    disabled
                                                                                />
                                                                            </>,
                                                                        ]}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <InputGroup
                                                                        label="Date of investment"
                                                                        inputs={[
                                                                            <>
                                                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                                    <DemoContainer components={["DatePicker", "MobileDatePicker"]}>
                                                                                        <MobileDatePicker
                                                                                            className={`${commoncss.datePickerContainer} ${commoncss.clickable}`}
                                                                                            value={item.date_Of_investment ? dayjs(item.date_Of_investment) : null}
                                                                                            onChange={(newValue) =>
                                                                                                HandleChange(
                                                                                                    {
                                                                                                        target: {
                                                                                                            name: "date_Of_investment",
                                                                                                            value: newValue ? newValue.toISOString() : "", // or newValue.format("YYYY-MM-DD")
                                                                                                        },
                                                                                                    },
                                                                                                    i
                                                                                                )
                                                                                            }
                                                                                            format="DD-MMM-YYYY"
                                                                                            slotProps={{
                                                                                                textField: {
                                                                                                    InputProps: {
                                                                                                        disableUnderline: true,
                                                                                                    },
                                                                                                    inputProps: {
                                                                                                        placeholder: "DD-MM-YYYY",
                                                                                                    },
                                                                                                    sx: {
                                                                                                        '& fieldset': {
                                                                                                            border: 'none',
                                                                                                        },
                                                                                                    },
                                                                                                },
                                                                                            }}
                                                                                            disabled={true}
                                                                                        />

                                                                                    </DemoContainer>
                                                                                </LocalizationProvider>
                                                                                <span className="icon">
                                                                                    <CalenderIcon
                                                                                        className="vaMiddle"
                                                                                        width={20}
                                                                                        height={20}
                                                                                    />
                                                                                </span>
                                                                            </>,
                                                                        ]}
                                                                    />
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <InputGroup
                                                                        label=" Value of investment"
                                                                        inputs={[
                                                                            <>
                                                                                <input
                                                                                    name="value_of_investment"
                                                                                    type="text"
                                                                                    defaultValue={item.value_of_investment}
                                                                                    disabled
                                                                                />
                                                                            </>,
                                                                        ]}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <InputGroup
                                                                        label=" No of shares bought"
                                                                        inputs={[
                                                                            <>
                                                                                <input
                                                                                    type="text"
                                                                                    defaultValue={item.no_of_shares}
                                                                                    name="no_of_shares"
                                                                                    onChange={(e) => HandleChange(e, i)}
                                                                                    disabled
                                                                                />
                                                                            </>,
                                                                        ]}
                                                                    />
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <InputGroup
                                                                        label="Total no shares in the company"
                                                                        inputs={[
                                                                            <>
                                                                                <input
                                                                                    type="text"
                                                                                    defaultValue={item.total_no_shares}
                                                                                    name="total_no_shares"
                                                                                    onChange={(e) => HandleChange(e, i)}
                                                                                    disabled
                                                                                />
                                                                            </>,
                                                                        ]}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <InputGroup
                                                                        label="Percentage holding"
                                                                        inputs={[
                                                                            <>
                                                                                <input
                                                                                    type="text"
                                                                                    name="holdings"
                                                                                    value={item.holdings.toLocaleString("en-IN")}
                                                                                    disabled
                                                                                />
                                                                            </>,
                                                                        ]}
                                                                    />

                                                                </div>
                                                                <div className="col-md-6">
                                                                    <InputGroup
                                                                        label="Non-controling interest Percentage"
                                                                        inputs={[
                                                                            <>
                                                                                <input
                                                                                    type="text"
                                                                                    name="non_controlling_interest"
                                                                                    value={item.non_controlling_interest.toLocaleString("en-IN")}
                                                                                    disabled
                                                                                />
                                                                            </>,
                                                                        ]}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <span className="input-label">Nature of relationship</span>
                                                                    <Select
                                                                        placeholder="Nature of relationship"
                                                                        name="nature_of_relationship"
                                                                        options={companyRelationShip.map((nr) => ({
                                                                            label: nr,
                                                                            value: nr,
                                                                        }))}
                                                                        className={`basic-multi-select w-100 mt-1 mb-2`}
                                                                        classNamePrefix="select"
                                                                        components={{
                                                                            ...animatedComponents,
                                                                            IndicatorSeparator: () => null,
                                                                            DropdownIndicator: CustomDropdownIndicator,
                                                                        }}
                                                                        styles={customStyles}
                                                                        onChange={(selectedOption) =>
                                                                            HandleChange(
                                                                                {
                                                                                    target: {
                                                                                        name: "nature_of_relationship",
                                                                                        value: selectedOption?.value || "",
                                                                                    },
                                                                                },
                                                                                i
                                                                            )
                                                                        }
                                                                        value={
                                                                            companyRelationShip
                                                                                .map((nr) => ({ label: nr, value: nr }))
                                                                                .find((opt) => opt.value === item?.nature_of_relationship) || null
                                                                        }
                                                                        isDisabled={true}
                                                                    />
                                                                </div>
                                                            </div>
                                                            {item.nature_of_relationship === "Subsidiary Company" && (
                                                                <>
                                                                    <div className="row">
                                                                        <div className="col-md-12">
                                                                            <span className="input-label">Browse control date FS</span>
                                                                            <Select
                                                                                placeholder="Select"
                                                                                options={allProjects.map((project) => ({
                                                                                    label: project?.project_name,
                                                                                    value: project?._id,
                                                                                }))}
                                                                                className={`basic-multi-select w-100 mt-1 mb-2`}
                                                                                classNamePrefix="select"
                                                                                components={{
                                                                                    ...animatedComponents,
                                                                                    IndicatorSeparator: () => null,
                                                                                    DropdownIndicator: CustomDropdownIndicator,
                                                                                }}
                                                                                styles={customStyles}
                                                                                onChange={(selectedOption) =>
                                                                                    setDetails((prev) => ({
                                                                                        ...prev,
                                                                                        browseFsCompanyId: selectedOption?.value || "",
                                                                                    }))
                                                                                }
                                                                                value={
                                                                                    projects
                                                                                        .map((project) => ({
                                                                                            label: project?.project_name,
                                                                                            value: project?._id,
                                                                                        }))
                                                                                        .find((opt) => opt.value === item?.prepare_preset_project_id) || null
                                                                                }
                                                                                isDisabled={true}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="col-md-12">
                                                                            <InputGroup
                                                                                label="Details of net-worth on the date of control"
                                                                                inputs={[
                                                                                    <>
                                                                                        <input
                                                                                            type="text"
                                                                                            disabled
                                                                                        />
                                                                                    </>,
                                                                                ]}
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    <div key={i}>
                                                                        <div className={investmentRegisterCss.radioButtonSection}>
                                                                            <span className="input-label" style={{ fontSize: "15px" }}>Add Other details</span>
                                                                            <span
                                                                                className="input-label"
                                                                                style={{ display: "flex", alignItems: "center", gap: "5px", fontSize: "15px" }}
                                                                                onClick={() => handleAddDetail("register", i)}
                                                                            >
                                                                                <PlusPrimaryIcon />
                                                                                Add Details
                                                                            </span>
                                                                        </div>
                                                                        {(extraDetails[i] || []).map((detail, j) => (
                                                                            <div
                                                                                key={j}
                                                                                style={{
                                                                                    display: "flex",
                                                                                    gap: "10px",
                                                                                    marginTop: "10px",
                                                                                    alignItems: "center",
                                                                                }}
                                                                            >   <div className="col-md-5">
                                                                                    <InputGroup
                                                                                        inputs={[
                                                                                            <>
                                                                                                <input
                                                                                                    type="text"
                                                                                                    placeholder="Type Something..."
                                                                                                    value={detail.field1 || ""}
                                                                                                    onChange={(e) =>
                                                                                                        handleDetailChange("register", i, j, "field1", e.target.value)
                                                                                                    }
                                                                                                />
                                                                                            </>,
                                                                                        ]}
                                                                                    />
                                                                                </div>
                                                                                <div className="col-md-5">
                                                                                    <InputGroup
                                                                                        inputs={[
                                                                                            <>
                                                                                                <input
                                                                                                    type="text"
                                                                                                    placeholder="Enter Amount..."
                                                                                                    value={detail.field2 || ""}
                                                                                                    onChange={(e) =>
                                                                                                        handleDetailChange("register", i, j, "field2", e.target.value)
                                                                                                    }
                                                                                                />
                                                                                            </>,
                                                                                        ]}
                                                                                    />
                                                                                </div>
                                                                                <div className="col-md-2">
                                                                                    <span>
                                                                                        <CrossGreyIcon
                                                                                            onClick={() => handleRemoveDetail("register", i, j)}
                                                                                        />
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        ))}
                                                                    </div>

                                                                    <div className="row mt-3">
                                                                        <div className="col-md-4">
                                                                            <button
                                                                                className={investmentRegisterCss.consoleBtn}
                                                                                // onClick={() => {
                                                                                //     GetAllConsoleEntry(item)
                                                                                //     setIsAdditional(false)
                                                                                // }}
                                                                            >
                                                                                Create consol entry
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                    <div>
                                                                        <div className={investmentRegisterCss.consoleEntryHeading}>Console Entry</div>
                                                                        <div className={investmentRegisterCss.consoleEntryCard}>
                                                                            <div className={investmentRegisterCss.consoleEntryItem}>
                                                                                <span style={{ color:"#4D6D64" }}>Non-controlling Asset</span>
                                                                                <span>0</span>
                                                                            </div>
                                                                            <div className={investmentRegisterCss.consoleEntryItem}>
                                                                                <span style={{ color:"#4D6D64" }}>Investment</span>
                                                                                <span>27200</span>
                                                                            </div>
                                                                            <div className={investmentRegisterCss.consoleEntryItem}>
                                                                                <span style={{ color:"#4D6D64" }}>Good will</span>
                                                                                <span>300</span>
                                                                            </div>
                                                                            <div className={investmentRegisterCss.consoleEntryItem}>
                                                                                <span style={{ color:"#4D6D64" }}>Other Inputs</span>
                                                                                <span>-1000</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )}
                                                            <div className="row">
                                                                <div className={`${investmentRegisterCss.radioButtonSection} col-md-12`}>
                                                                    <span className="input-label" style={{ fontSize: "15px" }}>Is the transaction covered as common control transaction?</span>
                                                                    <span>
                                                                        <RadioGroup
                                                                            row
                                                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                                                            name="control-transaction"
                                                                            className={investmentRegisterCss.radioSection}
                                                                        >
                                                                            <FormControlLabel
                                                                                value="yes"
                                                                                label="Yes"
                                                                                className={investmentRegisterCss.radioLabel}
                                                                                control={
                                                                                    <Radio
                                                                                        sx={{
                                                                                            "& .MuiSvgIcon-root": {
                                                                                                fontSize: 18,
                                                                                            },
                                                                                            color: "#D6D6D6",
                                                                                            "&.Mui-checked": { color: "#3AB67D" },
                                                                                        }}
                                                                                    />
                                                                                }
                                                                            />
                                                                            <FormControlLabel
                                                                                value="no"
                                                                                label="No"
                                                                                className={investmentRegisterCss.radioLabel}
                                                                                control={
                                                                                    <Radio
                                                                                        sx={{
                                                                                            "& .MuiSvgIcon-root": {
                                                                                                fontSize: 18,
                                                                                            },
                                                                                            color: "#D6D6D6",
                                                                                            "&.Mui-checked": { color: "#3AB67D" },
                                                                                        }}
                                                                                    />
                                                                                }
                                                                            />
                                                                        </RadioGroup>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </>
                                        ))}
                                </div>

                                <div>
                                    {additinalData.length > 0 &&
                                        additinalData.map((item, i) => (
                                            <div style={{ padding: "10px" }}>
                                                <Accordion className={investmentRegisterCss.accordian}>
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon />}
                                                        aria-controls="panel1a-content"
                                                        id="panel1a-header"
                                                        className={investmentRegisterCss.accordianHeader}
                                                    >
                                                        <div className={investmentRegisterCss.accordianHeaderContent}>
                                                            <span style={{ fontWeight: "600" }}>TRANCH {i + 2} <span style={{ marginLeft: "20px" }}>{item.date_Of_investment}</span></span>
                                                            <span style={{ marginRight: "20px", color: "#111111" }}> Investment value &nbsp;&nbsp; {Math.round(item.value_of_investment)}</span>
                                                        </div>
                                                    </AccordionSummary>
                                                    <AccordionDetails>
                                                        <div>
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <span className="input-label">Select Investment Company</span>
                                                                    <Select
                                                                        placeholder="Select Investment Company"
                                                                        name="investment_company_id"
                                                                        options={allCompany.map((det) => ({
                                                                            label: det.company_name,
                                                                            value: det._id,
                                                                        }))}
                                                                        className={`basic-multi-select w-100 mt-1 mb-2`}
                                                                        classNamePrefix="select"
                                                                        components={{
                                                                            ...animatedComponents,
                                                                            IndicatorSeparator: () => null,
                                                                            DropdownIndicator: CustomDropdownIndicator,
                                                                        }}
                                                                        styles={customStyles}
                                                                        onChange={(selectedOption) =>
                                                                            HandleChange(
                                                                                {
                                                                                    target: {
                                                                                        name: "investment_company_id",
                                                                                        value: selectedOption?.value || "",
                                                                                    },
                                                                                },
                                                                                i
                                                                            )
                                                                        }
                                                                        value={companyOptions.find((opt) => opt.value === item?.investment_company_id) || null}
                                                                    />
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <InputGroup
                                                                        label=" Company code"
                                                                        inputs={[
                                                                            <>
                                                                                <input
                                                                                    type="text"
                                                                                    value={item?.investment_company_code}
                                                                                />
                                                                            </>,
                                                                        ]}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <InputGroup
                                                                        label="Date of investment"
                                                                        inputs={[
                                                                            <>
                                                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                                    <DemoContainer components={["DatePicker", "MobileDatePicker"]}>
                                                                                        <MobileDatePicker
                                                                                            className={`${commoncss.datePickerContainer} ${commoncss.clickable}`}
                                                                                            value={item.date_Of_investment ? dayjs(item.date_Of_investment) : null}
                                                                                            onChange={(newValue) =>
                                                                                                HandleChange(
                                                                                                    {
                                                                                                        target: {
                                                                                                            name: "date_Of_investment",
                                                                                                            value: newValue ? newValue.toISOString() : "", // or newValue.format("YYYY-MM-DD")
                                                                                                        },
                                                                                                    },
                                                                                                    i
                                                                                                )
                                                                                            }
                                                                                            format="DD-MMM-YYYY"
                                                                                            slotProps={{
                                                                                                textField: {
                                                                                                    InputProps: {
                                                                                                        disableUnderline: true,
                                                                                                    },
                                                                                                    inputProps: {
                                                                                                        placeholder: "DD-MM-YYYY",
                                                                                                    },
                                                                                                    sx: {
                                                                                                        '& fieldset': {
                                                                                                            border: 'none',
                                                                                                        },
                                                                                                    },
                                                                                                },
                                                                                            }}
                                                                                        />

                                                                                    </DemoContainer>
                                                                                </LocalizationProvider>
                                                                                <span className="icon">
                                                                                    <CalenderIcon
                                                                                        className="vaMiddle"
                                                                                        width={20}
                                                                                        height={20}
                                                                                    />
                                                                                </span>
                                                                            </>,
                                                                        ]}
                                                                    />
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <InputGroup
                                                                        label=" Value of investment"
                                                                        inputs={[
                                                                            <>
                                                                                <input
                                                                                    name="value_of_investment"
                                                                                    type="text"
                                                                                    defaultValue={item.value_of_investment}
                                                                                />
                                                                            </>,
                                                                        ]}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <InputGroup
                                                                        label=" No of shares bought"
                                                                        inputs={[
                                                                            <>
                                                                                <input
                                                                                    type="text"
                                                                                    defaultValue={item.no_of_shares}
                                                                                    name="no_of_shares"
                                                                                    onChange={(e) => HandleChange(e, i)}
                                                                                />
                                                                            </>,
                                                                        ]}
                                                                    />
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <InputGroup
                                                                        label="Total no shares in the company"
                                                                        inputs={[
                                                                            <>
                                                                                <input
                                                                                    type="text"
                                                                                    defaultValue={item.total_no_shares}
                                                                                    name="total_no_shares"
                                                                                    onChange={(e) => HandleChange(e, i)}
                                                                                />
                                                                            </>,
                                                                        ]}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <InputGroup
                                                                        label="Percentage holding"
                                                                        inputs={[
                                                                            <>
                                                                                <input
                                                                                    type="text"
                                                                                    name="holdings"
                                                                                    value={item.holdings.toLocaleString("en-IN")}
                                                                                />
                                                                            </>,
                                                                        ]}
                                                                    />

                                                                </div>
                                                                <div className="col-md-6">
                                                                    <InputGroup
                                                                        label="Non-controling interest Percentage"
                                                                        inputs={[
                                                                            <>
                                                                                <input
                                                                                    type="text"
                                                                                    name="non_controlling_interest"
                                                                                    value={item.non_controlling_interest.toLocaleString("en-IN")}
                                                                                />
                                                                            </>,
                                                                        ]}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <span className="input-label">Nature of relationship</span>
                                                                    <Select
                                                                        placeholder="Nature of relationship"
                                                                        name="nature_of_relationship"
                                                                        options={companyRelationShip.map((nr) => ({
                                                                            label: nr,
                                                                            value: nr,
                                                                        }))}
                                                                        className={`basic-multi-select w-100 mt-1 mb-2`}
                                                                        classNamePrefix="select"
                                                                        components={{
                                                                            ...animatedComponents,
                                                                            IndicatorSeparator: () => null,
                                                                            DropdownIndicator: CustomDropdownIndicator,
                                                                        }}
                                                                        styles={customStyles}
                                                                        onChange={(selectedOption) =>
                                                                            HandleChange(
                                                                                {
                                                                                    target: {
                                                                                        name: "nature_of_relationship",
                                                                                        value: selectedOption?.value || "",
                                                                                    },
                                                                                },
                                                                                i
                                                                            )
                                                                        }
                                                                        value={
                                                                            companyRelationShip
                                                                                .map((nr) => ({ label: nr, value: nr }))
                                                                                .find((opt) => opt.value === item?.nature_of_relationship) || null
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {((registerdata[0]?.investment_company_id === item.investment_company_id && item.nature_of_relationship === "Subsidiary Company") || item.nature_of_relationship === "Subsidiary Company") && (
                                                            <>
                                                                <div className="row">
                                                                    <div className="col-md-12">
                                                                        <span className="input-label">Browse control date FS</span>
                                                                        <Select
                                                                            placeholder="Select"
                                                                            options={allProjects.map((project) => ({
                                                                                label: project?.project_name,
                                                                                value: project?._id,
                                                                            }))}
                                                                            className={`basic-multi-select w-100 mt-1 mb-2`}
                                                                            classNamePrefix="select"
                                                                            components={{
                                                                                ...animatedComponents,
                                                                                IndicatorSeparator: () => null,
                                                                                DropdownIndicator: CustomDropdownIndicator,
                                                                            }}
                                                                            styles={customStyles}
                                                                            onChange={(selectedOption) =>
                                                                                setDetails((prev) => ({
                                                                                    ...prev,
                                                                                    browseFsCompanyId: selectedOption?.value || "",
                                                                                }))
                                                                            }
                                                                            value={
                                                                                projects
                                                                                    .map((project) => ({
                                                                                        label: project?.project_name,
                                                                                        value: project?._id,
                                                                                    }))
                                                                                    .find((opt) => opt.value === item?.prepare_preset_project_id) || null
                                                                            }
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-md-12">
                                                                        <InputGroup
                                                                            label="Details of net-worth on the date of control"
                                                                            inputs={[
                                                                                <>
                                                                                    <input
                                                                                        type="text"
                                                                                        disabled
                                                                                    />
                                                                                </>,
                                                                            ]}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                
                                                                <div key={i}>
                                                                    <div className={investmentRegisterCss.radioButtonSection}>
                                                                        <span className="input-label" style={{ fontSize: "15px" }}>Add Other details</span>
                                                                        <span
                                                                            className="input-label"
                                                                            style={{ display: "flex", alignItems: "center", gap: "5px", fontSize: "15px" }}
                                                                            onClick={() => handleAddDetail("additional", i)}
                                                                        >
                                                                            <PlusPrimaryIcon />
                                                                            Add Details
                                                                        </span>
                                                                    </div>
                                                                    {(extraAdditionalDetails[i] || []).map((detail, j) => (
                                                                        <div
                                                                            key={j}
                                                                            style={{
                                                                                display: "flex",
                                                                                gap: "10px",
                                                                                marginTop: "10px",
                                                                                alignItems: "center",
                                                                            }}
                                                                        >   <div className="col-md-5">
                                                                                <InputGroup
                                                                                    inputs={[
                                                                                        <>
                                                                                            <input
                                                                                                type="text"
                                                                                                placeholder="Type Something..."
                                                                                                value={detail.field1 || ""}
                                                                                                onChange={(e) =>
                                                                                                    handleDetailChange("additional", i, j, "field1", e.target.value)
                                                                                                }
                                                                                            />
                                                                                        </>,
                                                                                    ]}
                                                                                />
                                                                            </div>
                                                                            <div className="col-md-5">
                                                                                <InputGroup
                                                                                    inputs={[
                                                                                        <>
                                                                                            <input
                                                                                                type="text"
                                                                                                placeholder="Enter Amount..."
                                                                                                value={detail.field2 || ""}
                                                                                                onChange={(e) =>
                                                                                                    handleDetailChange("additional", i, j, "field2", e.target.value)
                                                                                                }
                                                                                            />
                                                                                        </>,
                                                                                    ]}
                                                                                />
                                                                            </div>
                                                                            <div className="col-md-2">
                                                                                <span>
                                                                                    <CrossGreyIcon
                                                                                        onClick={() => handleRemoveDetail("additional", i, j)}
                                                                                    />
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                                <div className="row mt-3">
                                                                    <div className="col-md-4">
                                                                        <button
                                                                            className={investmentRegisterCss.consoleBtn}
                                                                            // onClick={() => {
                                                                            //     GetAllConsoleEntry(item)
                                                                            //     setIsAdditional(false)
                                                                            // }}
                                                                        >
                                                                            Create consol entry
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <div className={investmentRegisterCss.consoleEntryHeading}>Console Entry</div>
                                                                    <div className={investmentRegisterCss.consoleEntryCard}>
                                                                        <div className={investmentRegisterCss.consoleEntryItem}>
                                                                            <span style={{ color:"#4D6D64" }}>Non-controlling Asset</span>
                                                                            <span>0</span>
                                                                        </div>
                                                                        <div className={investmentRegisterCss.consoleEntryItem}>
                                                                            <span style={{ color:"#4D6D64" }}>Investment</span>
                                                                            <span>27200</span>
                                                                        </div>
                                                                        <div className={investmentRegisterCss.consoleEntryItem}>
                                                                            <span style={{ color:"#4D6D64" }}>Good will</span>
                                                                            <span>300</span>
                                                                        </div>
                                                                        <div className={investmentRegisterCss.consoleEntryItem}>
                                                                            <span style={{ color:"#4D6D64" }}>Other Inputs</span>
                                                                            <span>-1000</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                        <div className="row">
                                                            <div className={`${investmentRegisterCss.radioButtonSection} col-md-12`}>
                                                                <span className="input-label" style={{ fontSize: "15px" }}>Is the transaction covered as common control transaction?</span>
                                                                <span>
                                                                    <RadioGroup
                                                                        row
                                                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                                                        name="control-transaction"
                                                                        className={investmentRegisterCss.radioSection}
                                                                    >
                                                                        <FormControlLabel
                                                                            value="yes"
                                                                            label="Yes"
                                                                            className={investmentRegisterCss.radioLabel}
                                                                            control={
                                                                                <Radio
                                                                                    sx={{
                                                                                        "& .MuiSvgIcon-root": {
                                                                                            fontSize: 18,
                                                                                        },
                                                                                        color: "#D6D6D6",
                                                                                        "&.Mui-checked": { color: "#3AB67D" },
                                                                                    }}
                                                                                />
                                                                            }
                                                                        />
                                                                        <FormControlLabel
                                                                            value="no"
                                                                            label="No"
                                                                            className={investmentRegisterCss.radioLabel}
                                                                            control={
                                                                                <Radio
                                                                                    sx={{
                                                                                        "& .MuiSvgIcon-root": {
                                                                                            fontSize: 18,
                                                                                        },
                                                                                        color: "#D6D6D6",
                                                                                        "&.Mui-checked": { color: "#3AB67D" },
                                                                                    }}
                                                                                />
                                                                            }
                                                                        />
                                                                    </RadioGroup>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </div>
                                        ))}
                                </div>
                                <div className="mt-2">
                                    <div style={{ padding: "10px", width: "100%" }}>
                                        <InputGroup
                                            label={
                                                <div className="attachments-button-label">
                                                    <span>Add Remarks</span>
                                                    <div>
                                                        <input
                                                            type="file"
                                                            id="fileInput"
                                                            style={{ display: "none" }}
                                                            accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.eml,.msg"
                                                            multiple
                                                        />
                                                        <button
                                                            type="button"
                                                            className="attach-files-btn"
                                                            onClick={() => document.getElementById("fileInput").click()}
                                                        >
                                                            <AttachmentIcon className={commoncss.vaMiddle} width={18} />
                                                            <span>Attach files</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            }
                                            inputs={[
                                                <>
                                                    <textarea
                                                        placeholder="Type Something..."
                                                        rows={5}
                                                    />
                                                </>
                                            ]}
                                        />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </motion.div>
                </div>

            </div>

            {/* <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box>
                    <div className="col-12">
                        <input
                            type="button"
                            className="btn btn-defult"
                            value="X"
                            onClick={handleClose}
                            style={{ float: "right" }}
                        />
                        <div className="col-12">
                            <h5>Dilution</h5>
                            <div className="form-group mb-1 col-12">
                                <label>Date of divestment</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={dilutiondata.date_of_divest}
                                // onChange={(e) => handleDilutionChange(e, "date_of_divest")}
                                />
                            </div>
                            <div className="form-group mb-1 col-12">
                                <label>No. of shares divested</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={dilutiondata.no_of_share}
                                // onChange={(e) => handleDilutionChange(e, "no_of_share")}
                                />
                            </div>
                            <div className="form-group mb-1 col-12">
                                <label>Sale value</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={dilutiondata.sale}
                                // onChange={(e) => handleDilutionChange(e, "sale")}
                                />
                            </div>
                            <div className="form-group mb-1 col-12">
                                <label>Cost of Investment</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={dataValue}
                                    readOnly
                                />
                            </div>
                            <div className="form-group mb-1 col-12">
                                <input
                                    type="button"
                                    className="btn btn-primary1"
                                    value="Submit"
                                // onClick={() => handleDelution()}
                                />
                            </div>
                        </div>
                    </div>
                </Box>
            </Modal> */}

          <Modal open={open} onClose={handleClose}>
            <Box className={investmentRegisterCss.dilutionModalBox}>

            
                <div className={investmentRegisterCss.dilutionHeader}>
                <h2 className={investmentRegisterCss.dilutionTitle}>Dilution</h2>


                <span
                    className={investmentRegisterCss.dilutionCloseIcon}
                    onClick={handleClose}
                >
                    <CrossGreyIcon width={20} height={20} />
                </span>
                </div>


                <div className={investmentRegisterCss.dilutionBody}>

                <div className={investmentRegisterCss.dilutionField}>
                    <label className={investmentRegisterCss.dilutionLabel}>
                    Date Of Investment
                    </label>
                    <input
                    type="date"
                    className={investmentRegisterCss.dilutionInput}
                    />
                </div>

                <div className={investmentRegisterCss.dilutionField}>
                    <label className={investmentRegisterCss.dilutionLabel}>
                    No Of Shares Divested
                    </label>
                    <input
                    type="text"
                    placeholder="Placeholder text"
                    className={investmentRegisterCss.dilutionInput}
                    />
                </div>

                <div className={investmentRegisterCss.dilutionField}>
                    <label className={investmentRegisterCss.dilutionLabel}>
                    Sale Value
                    </label>
                    <input
                    type="text"
                    placeholder="Placeholder text"
                    className={investmentRegisterCss.dilutionInput}
                    />
                </div>

                <div className={investmentRegisterCss.dilutionField}>
                    <label className={investmentRegisterCss.dilutionLabel}>
                    Cost Of Investment
                    </label>
                    <input
                    type="text"
                    placeholder="Placeholder text"
                    className={investmentRegisterCss.dilutionInput}
                    disabled
                    />
                </div>
                </div>

                <div className={investmentRegisterCss.dilutionFooter}>

                <Button
                    btnColor={buttoncss.greyBg}
                    label="Cancel"
                    onClick={handleClose}
                />

                <Button
                    btnColor={buttoncss.primary}
                    label="Submit"
                />
                </div>
            </Box>
           </Modal>


            <InvestAdjustModal
                handleClose={handleClose}
                entryopen={entryopenModal}
                eqityshare={eqityshare}
                otherequityshare={otherequityshare}
                investvalue={investvalue}
                totaleqity={totaleqity}
                interest={interest}
                setfinalsum={setfinalsum}
                setFinalConsoleEntry={setFinalConsoleEntry}
                otherreservesurplus={otherreservesurplus}
                othereserve={othereserve}
                setEntryOpen={setEntryOpen}
                dateofinvest={dateofinvest}
            />
            {/* <BrowsFsModal
                setIsBrowsModalOpen={setIsBrowsModalOpen}
                isBrowsModalOpen={isBrowsModalOpen}
                allProjects={allProjects}
                details={details}
                setDetails={setDetails}
                handleSubmitFs={handleSubmitFs}
            /> */}

            <ConsoleEntry
                isConsoleEntryOpen={isConsoleEntryOpen}
                setIsConsoleEntryOpen={setIsConsoleEntryOpen}
                allConsoleEntry={allConsoleEntry}
                allRegisterData={null}  // code change needed
                handleChangeInputs={handleChangeInputs}
                consoleInvestmentValue={consoleInvestmentValue}
                handleNext={handleNext}
                showFirstTable={showFirstTable}
                setShowFirstTable={setShowFirstTable}
                additinalData={additinalData}
                isAdditional={isAdditional}
                finalHoldings={finalHoldings}
            />

            <AddOtherDetailsModal
                setIsOtherInputOpen={setIsOtherInputOpen}
                isOtherInputOpen={isOtherInputOpen}
                allOtherDetailsInputs={allOtherDetailsInputs}
                allotherdata={otherOptions}
                handleChangeDetails={handleChangeDetails}
                handleNew={addNewOthersDetails}
                handleDelete={deleteOthersDetails}
                handleSave={addAllOthersDetails}
            />

            <AddNewOptionsModal
                isOptionsModalOpen={isOptionsModalOpen}
                setIsOptionsModalOpen={setIsOptionsModalOpen}
                setOptions={setOptions}
                saveData={addNewOptionsDetails}
            />
        </>
    );
};

export default InvestmentData;
